import styled from "styled-components";

import { layout } from "/styles";

export const SegmentedControlWrapper = styled.div(
  layout.margin("expanded", "none", "none", "none"),
);

export const BadgeContainer = styled.div(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignContent: "center",
  fontSize: "12px",
  width: "16px",
  height: "16px",
  backgroundColor: theme.colors.brandSecondary,
  borderRadius: 20,
}));
